export var MAX_MESSAGE_SIZE = 2 /*KB*/ * 1024 /*MB*/ * 1024 /*GB*/ - 1;
export var KB_TO_B = 1024;
//# sourceMappingURL=ClauseValueType.js.map